module.exports = __webpack_public_path__ + "img/p5.c120bc40.png";